import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "d-flex justify-content-end pr-0" }
const _hoisted_2 = {
  key: 0,
  class: "material-symbols-outlined is-added-check-circle"
}

import CreateOrDeleteButton from "@/components/AllowAccessOfficeParts/createOrDeleteButtons/CreateOrDeleteButton.vue"
import ConfirmModal from "@/components/AllowAccessOfficeParts/createOrDeleteButtons/ConfirmModal.vue"
import getAllowAccessOfficeResponse from "@/types/responses/getAllowAccessOffice"
import Api from "@/services/api/ApiServiceFabrick"
import { Ref, ref, computed } from 'vue'
import i18n from '@/lang/i18n';

const addKey = "add"
const deleteKey = "delete"

export default /*@__PURE__*/_defineComponent({
  __name: 'CreateAndDeleteButtons',
  props: {
    accountId: {},
    operationOfficeId: {},
    allowAccessOffice: {},
    createAuthority: { type: Boolean },
    deleteAuthority: { type: Boolean }
  },
  emits: ['inactiveModal'],
  setup(__props: any, { emit: __emit }) {

const emits = __emit
const props = __props

const dialogState: Ref<boolean> = ref(false)
const activateDialogKey: Ref<string> = ref("")
const addConfirmMessage = i18n.global.t('pages.allowAccessOffice.confirmationModal.addConfirmMessage')
const deleteConfirmMessage = i18n.global.t('pages.allowAccessOffice.confirmationModal.deleteConfirmMessage')
const status: Ref<string> = ref("approved")
const isLoading: Ref<boolean> = ref(false)
const addOrDeleteMessage: Ref<string> = ref("")
const disabled: Ref<boolean> = ref(false)
const isSucceeded: Ref<boolean> = ref(true)

const confirmText = computed(() => {
  return activateDialogKey.value == addKey ? addConfirmMessage : deleteConfirmMessage
})

const resultMessageColor = computed(() => {
  return isSucceeded.value ? "#3c763d" : "#a94442"
})

const isNotViewPermissionAndAddedIcon = computed(() => {
  return !props.createAuthority && !props.deleteAuthority && props.allowAccessOffice.length
})

function activateDialog (key: string) {
  activateDialogKey.value = key
  dialogState.value = true
}

function inactivateDialog(bool: boolean) {
  dialogState.value = false
  disabled.value = false
  addOrDeleteMessage.value = ""
  if (bool || !isSucceeded.value) emits('inactiveModal', isSucceeded.value)
}

function requestAllowAccessOffice() {
  isLoading.value = true
  if (activateDialogKey.value == addKey) return addAllowAccessOffice()
  deleteAllowAccessOffice()
}

function addAllowAccessOffice() {
  const paramas = {
    account_id: props.accountId,
    operation_office_id: props.operationOfficeId,
    status: status.value,
  }
  Api().createAllowAccessOffice(paramas).then((data: any) => {
    success()
  }).catch((error: any) => {
    errorHandle(error.response)
  })
}

function deleteAllowAccessOffice() {
  if (!props.allowAccessOffice.length) return
  Api().deleteAllowAccessOffice(props.allowAccessOffice[0].id).then((data: any) => {
    success()
  }).catch((error: any) => {
    errorHandle(error.response)
  })
}

function success() {
  isLoading.value = false
  makeMessage(true)
  disabled.value = true
  isSucceeded.value = true
}

function makeMessage(bool: boolean) {
  const resultPrefix = i18n.global.t('pages.allowAccessOffice.confirmationModal.resultPrefix')
  const actionKey = activateDialogKey.value == addKey ?
    i18n.global.t('pages.allowAccessOffice.confirmationModal.approval') :
    i18n.global.t('pages.allowAccessOffice.confirmationModal.delete')
  const result = bool ?
    i18n.global.t('pages.allowAccessOffice.confirmationModal.success'):
    i18n.global.t('pages.allowAccessOffice.confirmationModal.failed')
  addOrDeleteMessage.value = resultPrefix + actionKey + result
}

function failed() {
  isSucceeded.value = false
  isLoading.value = false
  disabled.value = true
}

function errorHandle (res: any) {
  failed()
  switch (res.status) {
    case 401:
      makeMessage(false)
      break
    case 403:
      addOrDeleteMessage.value = i18n.global.t('pages.common.messages.forbidden')
      break
    case 422:
      addOrDeleteMessage.value = res.data.errors
      break
    default:
      makeMessage(false)
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (isNotViewPermissionAndAddedIcon.value)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, " check_circle "))
      : _createCommentVNode("", true),
    (props.createAuthority)
      ? (_openBlock(), _createBlock(CreateOrDeleteButton, {
          key: 1,
          btnName: _unref(i18n).global.t('pages.allowAccessOffice.confirmationModal.add'),
          btnStyle: "rgb(179, 184, 187)",
          btnClass: "ma-2 exec-btn",
          actionKey: addKey,
          isAdded: !props.allowAccessOffice.length,
          onAddRequested: activateDialog
        }, null, 8, ["btnName", "isAdded"]))
      : _createCommentVNode("", true),
    (props.deleteAuthority)
      ? (_openBlock(), _createBlock(CreateOrDeleteButton, {
          key: 2,
          btnName: _unref(i18n).global.t('pages.allowAccessOffice.confirmationModal.delete'),
          btnStyle: "rgb(179, 184, 187) !important",
          btnClass: "ma-2",
          btnColor: "error",
          actionKey: deleteKey,
          isAdded: props.allowAccessOffice.length ? true : false,
          onAddRequested: activateDialog
        }, null, 8, ["btnName", "isAdded"]))
      : _createCommentVNode("", true),
    _createVNode(ConfirmModal, {
      title: _unref(i18n).global.t('common.confirmationModal.title'),
      btnClass: "mt-0 ml-1",
      closeBtnClass: "mt-0",
      dialogState: dialogState.value,
      actionKey: activateDialogKey.value,
      confirmText: confirmText.value,
      isLoading: isLoading.value,
      message: addOrDeleteMessage.value,
      resultMessageColor: resultMessageColor.value,
      disabled: disabled.value,
      onExec: requestAllowAccessOffice,
      onCloseModal: inactivateDialog
    }, null, 8, ["title", "dialogState", "actionKey", "confirmText", "isLoading", "message", "resultMessageColor", "disabled"])
  ]))
}
}

})